import * as React from "react";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Chip, Stack } from "@mui/material";

export default function LinearProgressWithLabel(props) {
  const { progress } = props;
  return (
    <Box sx={{ alignItems: "center" }}>
      <Box
        sx={{
          width: "100%",
          mr: 1,
          display: props.value === 100 ? "none" : "block",
        }}
      >
        <LinearProgress variant="determinate" color="secondary" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {progress.percent < 100 ? (
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {`${Math.round(props.value)}%`}
            </Typography>
          ) : (
            <Chip size="small" label={"已完成"} color={"success"} />
          )}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`已完成: ${progress.completed}/${progress.total}`}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};
